import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const getChatThreads = createAsyncThunk("getChatThreads", async (data) => {
  const response = await API.get(`support_chat_threads`, {
    params: {
      status: data.statusFilter,
      page: 1,
      limit: 20,
      ...(data.searchTerm && { search: data.searchTerm })
    }
  });
  return response.data;
});

export const getChatHistory = createAsyncThunk("getChatHistory", async (data) => {
  const response = await API.get(`support_chat/${data.threadId}`);
  return response.data;
});

export const updateChatStatus = createAsyncThunk("updateChatStatus", async (data) => {
  const response = await API.put(`support_chat/${data.threadId}/status`, { status: data.status });
  return response.data;
});
